/**
 * ZTabs — Zephyr OS Design System
 *
 * Universal underline tab pattern. One pattern, all apps, no exceptions.
 * Spec: design-system.md Section 7 (Tabs).
 */

export default function ZTabs({ tabs = [], activeTab, onChange, accent = '#6B35B8' }) {
  return (
    <div
      style={{
        display: 'flex',
        gap: 24,
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        overflowX: 'auto',
        overflowY: 'hidden',
        flexWrap: 'nowrap',
        WebkitOverflowScrolling: 'touch',
        scrollbarWidth: 'none',
      }}
    >
      <style>{`.z-tabs-container::-webkit-scrollbar { display: none; }`}</style>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              padding: '12px 0',
              background: 'none',
              border: 'none',
              borderBottom: `2px solid ${isActive ? accent : 'transparent'}`,
              marginBottom: -1, // overlap container border
              color: isActive ? accent : '#b0b4c0',
              fontSize: 15,
              fontFamily: "'Inter', -apple-system, sans-serif",
              fontFeatureSettings: '"cv01", "ss03"',
              fontWeight: 500,
              textTransform: 'uppercase',
              letterSpacing: '1.5px',
              cursor: 'pointer',
              transition: 'all 150ms ease',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.color = '#f0f0f5';
                e.currentTarget.style.borderBottomColor = 'rgba(255,255,255,0.10)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.color = '#b0b4c0';
                e.currentTarget.style.borderBottomColor = 'transparent';
              }
            }}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
